import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import FormField from '../../../dynamicFormBuilder/FormField';
import ItemMasterFormLayout from './ItemMasterFormLayout';
import { GetLookupStaticData } from "../../../om/services/SalesOrderService";
import { ITEM_STATUSES, toSelectOptions } from "../transactionsTab/codeLists";
import { ItemSourceFlag, ItemTypeFlag } from "../../../const/Lookup";

// Shared {key,value} lists → the {ID, Text} shape GetLookupStaticData expects.
const toOptions = (list) => list.map((x) => ({ ID: x.key, Text: x.value }));

const searchpanel = [{ ID: 1, Title: 'Search Filters' }];

const buildInitialFields = () => {
  const init = {
    WarehouseID: '', ItemCode: '', ItemType: '', InventoryUnitUom: '',
    Description_1: '', Description_2: '', ItemSourceFlag: '', CareInstructions: '',
    ClassCode: '', SubClassCode: '', DateIntroduced: '', DateAvailable: '', DateExpiration: '',
    Status: '', AverageCost: '', LastCost: '', CreationUserId: '',
  };
  for (let i = 1; i <= 10; i++) { init[`UserDefinedCode${i}`] = ''; init[`UserDefinedReference${i}`] = ''; }
  return init;
};

// Item Master search panel — dynamic FormField from ItemMasterFormLayout (first 8 fields visible, rest via
// the field chooser). Same pattern as the transactions search; feeds the reused GetItemMasterMain endpoint.
const ItemMasterFilters = (props) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [forceRender, setForceRender] = useState(false);
  const [formFields, setformFields] = useState(buildInitialFields());
  const formRefs = useRef({});

  const selectionChanged = useCallback((e) => {
    let newItems = [...selectedItems];
    e.removedItems.forEach((item) => { const idx = newItems.indexOf(item); if (idx >= 0) newItems.splice(idx, 1); });
    if (e.addedItems.length) newItems = [...newItems, ...e.addedItems];
    setSelectedItems(newItems);
  }, [selectedItems]);

  const handleFormSubmit = () => { props.searchData(formFields); };
  const handleReset = () => { setformFields(buildInitialFields()); };
  const handleFieldChange = useCallback(() => {}, []);

  const handleFormLoad = useCallback(() => {
    GetLookupStaticData("Status", toSelectOptions(ITEM_STATUSES), formRefs, setForceRender, forceRender);
    GetLookupStaticData("ItemType", toOptions(ItemTypeFlag), formRefs, setForceRender, forceRender);
    GetLookupStaticData("ItemSourceFlag", toOptions(ItemSourceFlag), formRefs, setForceRender, forceRender);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AccordionReact
      dataSource={searchpanel}
      collapsible={true}
      multiple={false}
      animationDuration={300}
      selectedItems={selectedItems}
      onSelectionChanged={(e) => { if (e.currentTarget === e.target) selectionChanged(e); }}
      itemTitleRender={() => (
        <Toolbar className="accordian-toolbar">
          <Item location="before">
            <div className="title">
              <h6 style={{ color: window._env_.Color2 }}>{'IM Item Management (Item Master)'}</h6>
            </div>
          </Item>
          <Item location="after">
            <Button className="accordianButton" onClick={handleFormSubmit} text="Search" type="default" />
          </Item>
          <Item location="after">
            <Button className="accordianButton" onClick={handleReset} text="Reset" />
          </Item>
        </Toolbar>
      )}
      itemRender={() => (
        <div>
          <FormField
            currrentUser={props.currentUser}
            layoutId='0046d046-2f34-4b56-9a21-0046aabbccee'
            layoutName='ItemManagementItemMaster'
            defaultFormSchema={ItemMasterFormLayout}
            formFields={formFields}
            setformFields={setformFields}
            handleFieldValueChange={handleFieldChange}
            DYNAMICFORMSETTING={props.DYNAMICFORMSETTING}
            formRefs={formRefs}
            onFormLoad={handleFormLoad}
            noSpacingBeforeFirstRow={true}
          />
        </div>
      )}
      id="accordion-container" className="accordion-height"
    />
  );
};

function mapStateToProps(state) { return { oidc: state.oidc }; }
export default connect(mapStateToProps)(ItemMasterFilters);
